"use client"

import { PayPalScriptProvider } from "@paypal/react-paypal-js"
import React from "react"
import { PAYPAL_CLIENT_ID, isPaypalConfigured } from "@lib/constants"

type PaypalWrapperProps = {
  children: React.ReactNode
}

const PaypalWrapper: React.FC<PaypalWrapperProps> = ({ children }) => {
  if (!isPaypalConfigured()) {
    // Children render WITHOUT a PayPalScriptProvider here. That is only safe
    // because everything calling usePayPalScriptReducer() guards on
    // isPaypalConfigured() first — that hook throws with no provider, and the
    // throw used to blank the entire route (#102). If you nest a new
    // PayPal-dependent component under this wrapper, guard it the same way.
    return <>{children}</>
  }

  return (
    <PayPalScriptProvider
      options={{
        clientId: PAYPAL_CLIENT_ID!,
        currency: "GBP",
        intent: "capture",
      }}
    >
      {children}
    </PayPalScriptProvider>
  )
}

export default PaypalWrapper
